import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sun, ArrowRight } from "lucide-react";
import { useT } from "../i18n/LanguageContext";

const DEADLINE = new Date("2026-08-31T23:59:59+02:00");

const remaining = () => {
  const diff = DEADLINE.getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    minutes: Math.floor((diff % 3600000) / 60000),
  };
};

export const SummerSaleBanner = () => {
  const { lang } = useT();
  const [left, setLeft] = useState(remaining);

  useEffect(() => {
    const iv = setInterval(() => setLeft(remaining()), 30000);
    return () => clearInterval(iv);
  }, []);

  if (!left) return null;

  const de = lang === "de";
  const units = de
    ? [["Tage", left.days], ["Std", left.hours], ["Min", left.minutes]]
    : [["days", left.days], ["hrs", left.hours], ["min", left.minutes]];

  return (
    <section
      data-testid="summer-sale-banner"
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(120deg, #fff7e6 0%, #fdf3d9 45%, #f0f6e4 100%)" }}
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-5 sm:py-6 flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          <div
            className="h-11 w-11 rounded-2xl flex items-center justify-center text-white flex-shrink-0 shadow-md"
            style={{ background: "linear-gradient(135deg, #f59e0b 0%, #65a30d 100%)" }}
          >
            <Sun className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-widest font-bold" style={{ color: "#b45309" }}>
              {de ? "Sommer-Sale · nur bis 31. August" : "Summer Sale · until August 31"}
            </div>
            <div className="font-display font-bold text-base sm:text-lg text-slate-900 leading-snug">
              {de ? (
                <>Nur <span style={{ color: "#b45309" }}>30% statt 40%</span> Performance-Fee — du behältst 70% deiner Gewinne.</>
              ) : (
                <>Only <span style={{ color: "#b45309" }}>30% instead of 40%</span> performance fee — you keep 70% of your profits.</>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-4 flex-wrap">
          <div className="flex items-center gap-2" data-testid="summer-sale-countdown">
            {units.map(([label, value]) => (
              <div key={label} className="text-center px-2.5 py-1.5 rounded-xl bg-white/80 border border-amber-200 min-w-[52px]">
                <div className="font-mono-tab font-bold text-lg text-slate-900 leading-none">{value}</div>
                <div className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold mt-0.5">{label}</div>
              </div>
            ))}
          </div>
          <Link
            to="/register"
            data-testid="summer-sale-cta"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-white text-sm font-display font-semibold shadow-md transition-transform hover:scale-[1.03]"
            style={{ background: "linear-gradient(135deg, #f59e0b 0%, #65a30d 100%)" }}
          >
            {de ? "Jetzt einsteigen" : "Start now"} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
